import React from "react";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./routes/Home";
import Differ from "./routes/Differ";
import TransTool from "./routes/TransTool";
import LocalSearch from "./routes/LocalSearch";
import Workbench from "./routes/Workbench";
import BatchTranslate from "./routes/BatchTranslate";
import DataDiff from "./routes/DataDiff";
import Terms from "./routes/Terms";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/differ" element={<Differ />} />
        <Route path="/transTool" element={<TransTool />} />
        <Route path="/localSearch" element={<LocalSearch />} />
        <Route path="/workbench" element={<Workbench />} />
        <Route path="/batchTranslate" element={<BatchTranslate />} />
        <Route path="/dataDiff" element={<DataDiff />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <ToastContainer theme="dark" />
    </Router>
  );
}

export default App;
